(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
    var details = menu.querySelector(':scope > details');
    if (!details) return;
    var summary = details.querySelector(':scope > summary');
    var closeTimer = null;

    menu.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    });

    menu.addEventListener('mouseleave', function () {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 200);
    });
  });
})();

(function () {
  var bar = document.querySelector('.announcement-bar-section');
  if (!bar) return;

  function setHeight() {
    document.documentElement.style.setProperty('--hs-announcement-bar-height', bar.offsetHeight + 'px');
  }

  setHeight();
  window.addEventListener('resize', setHeight);
  if ('ResizeObserver' in window) {
    new ResizeObserver(setHeight).observe(bar);
  }
})();
